import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { useAbility } from '../../../modules/users/AbilityContext';
import { getFindActiveBannersKey } from './banners.keys';
import { findActiveBanners } from './banners.repository';
import { FindActiveBannersOutput } from './banners.types';

export const ACTIVE_BANNERS_LIMIT = 50;

export const useFindActiveBanners = (options?: UseDataQueryOptions) => {
  const ability = useAbility();

  return useDataQuery<FindActiveBannersOutput>(
    {
      queryKey: getFindActiveBannersKey(ACTIVE_BANNERS_LIMIT),
      queryFn: async () => {
        const response = await findActiveBanners(ACTIVE_BANNERS_LIMIT);

        if (!response.ok || !response.data) {
          throw response.originalError;
        }

        return response.data;
      },
    },
    { enabled: ability.can('read', 'banners'), ...options },
  );
};
